<template>
<div class="choose-batch-box">
  <template v-if="batchAttributes.length">
    <a-select
        v-model="formData.batchAttrs[0].attrCode"
        allow-clear
        placeholder="请选择指定批属性"
        @change="changeQuality"
    >
      <a-select-option
          v-for="item in batchAttributes"
          :key="item.value"
          :value="item.value"
      >{{item.label}}</a-select-option>
    </a-select>
    <!--  <component-->
    <!--      :is="currentOption.type"-->
    <!--      v-if="formData.batchAttrs[0].attrCode"-->
    <!--      v-model="formData.batchAttrs[0].attrValue"-->
    <!--      :placeholder="currentOption.placeholder"-->
    <!--      value-format="YYYY-MM-DD"-->
    <!--      :max-length="32"-->
    <!--  />-->
    <a-select
        v-if="formData.batchAttrs[0].attrCode"
        v-model="formData.batchAttrs[0].attrValue"
        allow-clear
        show-search
        placeholder="请选择"
        @change="onAttrValueChange"
    >
      <a-select-option
          v-for="item in currentOptions"
          :key="item"
          :value="item"
      >{{item}}</a-select-option>
    </a-select>
  </template>

</div>
</template>

<script>
import { getBatchAttrs } from "@/api/warehouse";

const defaultData = {
  attrCode: undefined,
  attrName: '',
  attrValue: undefined
}

export default {
  name: 'OutGoodsBatch',
  props:{
    formData:{
      type:Object,
    }
  },
  data() {
    return {
      chooseRow: {},
      batchAttributes:[],
    }
  },
  computed:{
    currentOptions(){
      if(this.formData?.batchAttrs&&this.formData?.batchAttrs[0]){
        return this.batchAttributes.find(item=>item.value === this.formData?.batchAttrs[0]?.attrCode).options
      }
      return []

    }
  },
  mounted(){ // 兼容数据格式，后端batchAttrs是个数组，但oms这边只有一个，后端可能是为了兼容w多批次把数据结构弄的数组（取最后一个）
    this.init()
    if(!this.formData.batchAttrs) { // 不存在
      this.$set(this.formData,'batchAttrs',[{...defaultData}])
    }else {
      this.$set(this.formData,'batchAttrs',[{...defaultData,...this.formData.batchAttrs.pop()}])
    }
  },
  methods: {
    async init() {
      const res = await getBatchAttrs({goodsId: this.formData.skuId,needAttributeValues: true})
      const { batchAttribute } = res
      this.batchAttributes = batchAttribute.map(item=>{
        return {
          label: item.fieldName,
          value: item.humpFieldCode || item.fieldCode,
          // value: item.fieldCode,
          options: item.values,
        }
      }) || []

      this.$nextTick(()=>{
        if(this.formData.batchAttrs[0]?.attrValue) {
          this.$emit("change", this.formData.batchAttrs[0])
        }
      })
    },
    changeQuality(value) {
      const attrObj = this.batchAttributes.find(item=>item.value === value)
      if(attrObj) {
        this.$set(this.formData,'batchAttrs',[{
          attrCode:attrObj.value,
          attrName: attrObj.label,
          attrValue: ''
        }] )
      }else {
        this.$set(this.formData,'batchAttrs',[{...defaultData}] )
      }

    },
    onAttrValueChange(){
      this.$emit("change", this.formData.batchAttrs[0])
    }
  }
}
</script>

<style lang="less" scoped>
.choose-batch-box {
  display: flex;
  gap: 8px;
}
.bath-modal {
  .ant-form-item {
    width: 100%;
    .ant-calendar-picker {
      width: 100%;
    }
  }
}
</style>
